import { useEffect } from 'react';
import { useLayoutEffect } from 'react';
import { useRef } from 'react';
import { classNames } from 'libs/react';
import { useMeasure } from 'libs/react';
import { useState } from 'libs/react';
import { React } from 'libs/react';
import './Toggle.scss';
/**
 * @component Toggle
 * @since 1.0.0
 */
export function Toggle(props) {
    var _a;
    const { style, required, disabled } = Object.assign({ style: 'normal' }, props);
    const options = (_a = props.options) !== null && _a !== void 0 ? _a : [];
    if (options[0] == null)
        options[0] = { value: '1', label: 'On' };
    if (options[1] == null)
        options[1] = { value: '0', label: 'Off' };
    const node = useRef(null);
    const head = useRef(null);
    const tail = useRef(null);
    const thumb = useRef(null);
    const [bounds] = useMeasure(node);
    const [toggled, setToggled] = useState(false);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        if (disabled) {
            return;
        }
        const newToggled = !toggled;
        setToggled(newToggled);
        // Call onChange directly here
        if (props.onChange) {
            props.onChange(newToggled ? options[1].value : options[0].value);
        }
    }
    useEffect(() => {
        if (options[1].value == props.value) {
            setToggled(true);
        }
        else {
            setToggled(false);
        }
    }, [props.value, options[1].value]);
    useLayoutEffect(() => {
        if (node.current == null ||
            thumb.current == null ||
            head.current == null ||
            tail.current == null) {
            return;
        }
        head.current.style.width = '';
        tail.current.style.width = '';
        const headW = head.current.getBoundingClientRect().width;
        const tailW = tail.current.getBoundingClientRect().width;
        const span = Math.max(headW, tailW);
        head.current.style.width = span + 'px';
        tail.current.style.width = span + 'px';
        const size = span + thumb.current.getBoundingClientRect().width;
        node.current.style.setProperty('--size', size + 'px');
        node.current.style.setProperty('--span', span + 'px');
    }, [bounds.width, bounds.height]);
    const h = Object.assign({ style: 'normal' }, options[0]);
    const t = Object.assign({ style: 'normal' }, options[1]);
    const className = classNames('toggle', 'toggle--' + style, { 'toggle--is-toggled': toggled }, { 'toggle--is-required': required }, { 'toggle--is-disabled': disabled }, props.className);
    return (React.createElement("div", { ref: node, className: className, onClick: onClick },
        React.createElement("div", { className: "toggle-track" },
            React.createElement("div", { ref: head, className: classNames('toggle-head', 'toggle-head--' + h.style) }, h.label),
            React.createElement("div", { ref: tail, className: classNames('toggle-tail', 'toggle-tail--' + t.style) }, t.label),
            React.createElement("div", { ref: thumb, className: "toggle-thumb" }))));
}
